/* eslint-disable */
import gaAsync from "@/js/common/Domain/Service/gaAsync";
import tourCriteriaService from "@/js/common/Domain/Service/tourCriteria";
import MealsRepository from "@/js/common/Domain/Repository/Meals";

var mealChangeTimeout;
let MealDropdownView = Backbone.View.extend({
	label: 'Питание',
	dataMealsOld: null,
	allText: 'Любое',
	countryData: null,
	departureCityData: null,
	scrollToElement: function (e) {
		var currenPosition = $(document).scrollTop(),
			windowHeight = $(window).height(),
			headerHeight = $('.headerContainer').height(),
			menuHeight = $('.menuContainer').height(),
			elementPosition = this.$inputText.offset().top,
			self = this,
			scrollTo;

		scrollTo = elementPosition;

		headerHeight ? scrollTo -= headerHeight : '';
		menuHeight ? scrollTo -= menuHeight : '';

		scrollTo -= 50;

		setTimeout(function () {
			self.$el.addClass("open");
		}, 1);

		if (elementPosition > currenPosition + windowHeight || elementPosition < currenPosition) {
			$("html,body").animate({scrollTop: scrollTo}, 200);
			return true;
		}

		return false;
	},
	$checkboxes: function () {
		this.$checkboxes =  $('input[type="checkbox"]', this.$el);
	},
	$inputText: function () {
		this.$inputText = $('.formInput', this.$el);
	},
	$inputTextLabel: function () {
		this.$inputTextLabel = $('.formInputLabel', this.$el);
	},
	setValue: function (model) {
		var text = [],
			meals = [];

		if (!model || !model.length) {
			this.$checkboxes.not('[value="all"]').prop('checked', false);
			this.$checkboxes.filter('[value="all"]').prop('checked', true);
			text = this.allText;
		} else {
			_.each(this.$checkboxes, function (checkbox) {
				var $checkbox = $(checkbox),
					meal = model.get($checkbox.val());

				if (meal && $checkbox.val() != "all") {
					$checkbox.prop('checked', true);
					meals.push(model.get($checkbox.val()));
				} else {
					$checkbox.prop('checked', false);
				}

			});

			if (meals.length == 1) {
				text = meals[0].get('code') + ' - ' + meals[0].get('name');
			} else {
				_.each(meals, function (meal) {
					text.push(meal.get('code'));
				});
				text = text.join(', ');
			}
		}
		this.$inputText.val(text);
		this.setInputTextLabel(text);
	},
	setInputTextLabel: function (text) {
		if (this.$inputTextLabel.length) {
			this.$inputTextLabel.text(text);
		}
	},
	modelChanged: function (event, model, context) {
		var from, to;
		if (!context || context.initiator !== 'view') {
			this.setValue(model);
		}
	},
	initEvents: function () {
		var self = this,
			$formDropdownContent = self.$el.find(".dropDown");
		self.$inputTextLabel.on('click', function () {
			if(!$formDropdownContent.is(":visible")) {
				gaAsync(function() {
					ga('send', 'event', 'SideBar Filter', 'food_open');
				});
			}
			self.$el.toggleClass("open")
		});

		$(document).click(function (event) {
			if(!$(event.target).closest(".serpFilterItem.meal").length) {
				self.$el.removeClass("open")
			}
		});

		this.model.on('change:model', $.proxy(this.modelChanged, this));
	},
	initDomEvents: function () {
		var self = this;
		_.each(this.$checkboxes, function (checkbox) {
			var $checkbox = $(checkbox);
			$checkbox.change($.proxy(self.checkboxChanged, self));
		});
	},
	checkboxChanged: function (event) {
		var text = [],
			self = this,
			checkboxState,
			defaultMeals,
			dataMeals,
			departureCityType,
			meals = [];

		tourCriteriaService.addTourCriteriaChangedField('meals');

		if ($(event.target).is('[value="all"]') && !this.$checkboxes.filter(':checked').length) {
			departureCityType = this.departureCityData && this.departureCityData.get('model') ? this.departureCityData.get('model').get('type') : null;
			defaultMeals = departureCityType ? this.countryData.get('model').at(0).get(departureCityType + 'TourCriteria').meals : (this.countryData.get('model') ? this.countryData.get('model').at(0).get('tourCriteria').meals : []);

			console.log('defaultMeals', defaultMeals);
			if (!defaultMeals.length) {
				this.$checkboxes.not('[value="all"]').prop('checked', false);
				this.$checkboxes.filter('[value="all"]').prop('checked', true);
				text = this.allText;
			} else {
				_.each(this.$checkboxes.not('[value="all"]'), function (checkbox) {
					var $checkbox = $(checkbox),
						model;

					if (_.contains(defaultMeals, parseInt($checkbox.val(), 10))) {
						$checkbox.prop('checked', true);
						model = MealsRepository.repository.get($checkbox.val());
						if (model) {
							meals.push(model);
						}
					}
				});

				if (meals.length == 1) {
					text = meals[0].get('code') + ' - ' + meals[0].get('name');
				} else {
					_.each(meals, function (meal) {
						text.push(meal.get('code'));
					});
					text = text.join(', ');
				}
			}

		} else if ($(event.target).is('[value="all"]') || !this.$checkboxes.not('[value="all"]').filter(':checked').length) {
			this.$checkboxes.not('[value="all"]').prop('checked', false);
			this.$checkboxes.filter('[value="all"]').prop('checked', true);
			text = this.allText;
		} else {
			this.$checkboxes.filter('[value="all"]').prop('checked', false);
			_.each(this.$checkboxes.not('[value="all"]'), function (checkbox) {
				var $checkbox = $(checkbox),
					model;

				if ($checkbox.is(':checked')) {
					model = MealsRepository.repository.get($checkbox.val());
					if (model) {
						meals.push(model);
					}
				}
			});

			if (meals.length == 1) {
				text = meals[0].get('code') + ' - ' + meals[0].get('name');
			} else {
				_.each(meals, function (meal) {
					text.push(meal.get('code'));
				});
				text = text.join(', ');
			}
		}

		this.$inputText.val(text);
		this.setInputTextLabel(text);

		dataMeals = new MealsRepository(meals);
		this.model.set('model', dataMeals, {initiator: 'view'});
		console.log('Changed meals: ' + dataMeals.pluck('code').join(', '));
	},
	initialize: function (options) {
		var model = this.model.get('model');
		this.countryData = options.countryData;
		this.departureCityData = options.departureCityData;
		if (options && options.allText !== undefined) {
			this.allText = options.allText;
		}

		this.$checkboxes();
		this.$inputText();
		this.$inputTextLabel();

		this.initEvents();
		this.initDomEvents();
		this.setValue(model);
	}
});

export default MealDropdownView;